import app from 'flarum/forum/app';
import Notification from 'flarum/components/Notification';
// import { isPermanentSuspensionDate } from '../helpers/suspensionHelper';

export default class PullFrontedNotification extends Notification {
  icon() {
    return '';
  }

  img() {
    return `${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/img-zt-tj.png`;
  }

  href() {
    let post = this.attrs.notification.subject();
    if (!post) {
      return;
    }
    return app.route.post(post);
  }

  content() {
    const notification = this.attrs.notification;
    let title = notification.content().discussion.title;
    let username = notification.fromUser().username();
    return app.translator.trans('dl_discussion_controller.forum.notices.admin_pull_front_text',
    {username:username,title:title});

  }
}
